import { render, staticRenderFns } from "./DsTable.vue?vue&type=template&id=5d5ca54b"
import script from "./DsTable.vue?vue&type=script&lang=js"
export * from "./DsTable.vue?vue&type=script&lang=js"
import style0 from "./DsTable.vue?vue&type=style&index=0&id=5d5ca54b&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d5ca54b')) {
      api.createRecord('5d5ca54b', component.options)
    } else {
      api.reload('5d5ca54b', component.options)
    }
    module.hot.accept("./DsTable.vue?vue&type=template&id=5d5ca54b", function () {
      api.rerender('5d5ca54b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/datasource/DsTable.vue"
export default component.exports